var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.457,
    height: 50.496,
    viewBox: "0 0 50.457 50.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5785",
    "data-name": "Group 5785",
    transform: "translate(9108.793 -5984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6133",
    "data-name": "Path 6133",
    d: "M198.718,101.829a25.246,25.246,0,0,0-44.15-15.05,25.407,25.407,0,0,0-3.325,28.526,1.772,1.772,0,0,0,3.133-1.656,21.788,21.788,0,0,1,2.859-24.5,21.7,21.7,0,1,1,1.984,30.619,1.774,1.774,0,0,0-2.34,2.668,25.017,25.017,0,0,0,16.623,6.28c.547,0,1.108-.014,1.655-.055a25.232,25.232,0,0,0,23.56-26.829Z",
    transform: "translate(-9257.109 5905.783)",
    fill: "#26c6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6134",
    "data-name": "Path 6134",
    d: "M297.389,203.7a1.748,1.748,0,0,0,1.245.506,1.782,1.782,0,0,0,1.272-.534l10.644-10.849c.014-.014.027-.041.055-.055l.068-.068a.241.241,0,0,1,.055-.068c.014-.027.041-.055.055-.082s.027-.041.041-.068l.123-.246c.014-.027.014-.055.027-.082s.014-.055.027-.082.014-.055.027-.082.014-.055.014-.082.014-.055.014-.082.014-.055.014-.082v-.328c0-.027-.014-.055-.014-.082s-.014-.055-.014-.082-.014-.055-.014-.082a.2.2,0,0,0-.027-.082c-.014-.027-.014-.055-.027-.082s-.014-.055-.027-.082l-.123-.246c-.014-.027-.027-.041-.041-.068s-.041-.055-.055-.082a.24.24,0,0,0-.055-.068c-.014-.027-.041-.041-.068-.068s-.027-.041-.055-.055l-10.644-10.849a1.771,1.771,0,0,0-2.531,2.476l9.413,9.632-9.427,9.6a1.772,1.772,0,0,0,.027,2.5Z",
    transform: "translate(-9387.069 5817.647)",
    fill: "#26c6da"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMore);
export default __webpack_public_path__ + "static/media/viewMore.d26f52608809f0f13e2faac7d7dc3ae4.svg";
export { ForwardRef as ReactComponent };